export default __webpack_public_path__ + "static/media/spin-bg-2.be81864a.png";